import React, { useState } from 'react';
import Icon from './Icon';
import { THEMES, getStoredTheme, setTheme } from '../../utils/theme';
import './ThemeSetting.css';

const LABEL = { system: 'System', light: 'Light', dark: 'Dark' };
const HINT = { system: 'Match your device', light: 'Always light', dark: 'Always dark' };
const ICON = { system: 'settings', light: 'lightning', dark: 'sparkle' };

/** Appearance picker for the Settings pages — a three-way choice, saved on this device. */
export default function ThemeSetting() {
  const [pref, setPref] = useState(getStoredTheme);
  const choose = (t) => setPref(setTheme(t));
  return (
    <section className="z-section" aria-labelledby="set-appearance">
      <h2 className="z-section-title" id="set-appearance">Appearance</h2>
      <div className="z-surface theme-setting" role="radiogroup" aria-label="Theme">
        {THEMES.map(t => (
          <button key={t} type="button" role="radio" aria-checked={pref === t} className={`theme-opt${pref === t ? ' active' : ''}`} onClick={() => choose(t)}>
            <Icon name={ICON[t]} size={18} />
            <span className="theme-opt-label">{LABEL[t]}</span>
            <span className="theme-opt-hint">{HINT[t]}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
